module.exports = __webpack_public_path__ + "static/media/banner-bg.7f6e8ecc.svg";